import { call } from 'redux-saga/effects';

import Logger from '../../../tools/Logger';
import * as UseCaseHelpers from '../helpers';

import * as replayTrackHelper from './helper';

const log = Logger.child({ component: 'mediator/useCases/replayTrack' });

export function* replayTrack(action) {
  const { trackToken, sourceId, eventSource } = action.payload;
  const isAPS = yield call(UseCaseHelpers.isAPS, action);

  if (!trackToken || !sourceId) {
    log.error(
      { obj: { trackToken, sourceId } },
      'replayTrack(): improper usage of the use case action. One of input parameters out of trackToke/sourceId/sourceType was null',
    );
  }

  if (isAPS) {
    yield call(replayTrackHelper.replayAPSTrack, sourceId, trackToken, eventSource);
    return;
  }

  return yield call(
    replayTrackHelper.replayStationTrack,
    sourceId,
    trackToken,
    eventSource,
    action,
  );
}
